<template>
  <card :has-height-medium="true" :title="title" :icon="icon" @ps-done="psDone">

    <refresh-button slot="button" label="Refresh" :isLoading="isLoading" @refresh="delayedFetch"/>

    <card-toolbar slot="toolbar" class="is-upper" :class="(status.toolbarClass)?status.toolbarClass:null">
      <div v-if="status.text" slot="left">{{ status.text }}</div>
      <span v-if="(status.label || status.labelIcon)" class="tag" :class="status.labelClass" slot="right">
        <b-icon v-if="status.labelIcon" :icon="status.labelIcon" custom-size="default"/>
        <span v-if="status.label">{{ status.label }}</span>
      </span>
    </card-toolbar>

    <div class="stuffed-list has-mobile-dividers" :class="{'has-dividers':hasDividers}">
      <b-loading :is-full-page="false" :active="isLoading"/>
      <stuffed-item v-for="item in items" :key="item.id" :item="item" :is-likeable="isLikeable" :isDismissable="isDismissable"/>
    </div>

    <card-load-more-sample slot="footer"></card-load-more-sample>

  </card>

</template>

<script>
  import RefreshButton from '@/components/RefreshButton'
  import CardToolbar from '@/components/CardToolbar'
  import StuffedItem from '@/components/StuffedItem'
  import CardLoadMoreSample from '@/components/CardLoadMoreSample'
  import Card from '@/components/Card'
  import axios from 'axios'
  export default {
    name: "UpdatesCardSample",
    components: {
      RefreshButton,
      CardToolbar,
      StuffedItem,
      CardLoadMoreSample,
      Card
    },
    props: {
      title: {
        type: String,
        default: null,
      },
      icon: {
        type: String,
        default: null,
      },
      dataUrl: {
        type: String,
        default: null,
      },
      isLikeable: {
        type: Boolean,
        default: false,
      },
      isDismissable: {
        type: Boolean,
        default: false,
      },
      hasDividers: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        ps: null,
        isLoading: false,
        items: [],
        status: {},
      }
    },
    mounted() {
      this.fetchData()
    },
    methods: {
      psDone(ps) {
        this.ps = ps
      },

      /*
      * This is an imitation, to show the loading state
      * We delay for 500ms
      * In production, just use fetchData()
      * */
      delayedFetch() {
        this.isLoading = true

        this.items = []

        this.status = {
          text: 'Fetching data...',
          labelClass: 'is-info',
          labelIcon: 'shuffle-variant',
        }

        setTimeout(() => {
          this.fetchData()
        }, 500)
      },
      fetchData() {
        this.isLoading = true

        this.items = []

        this.status = {
          text: 'Fetching data...',
          labelClass: 'is-info',
          labelIcon: 'shuffle-variant',
        }

        axios
          .get(this.dataUrl)
          .then(r => {
            this.isLoading = false

            if (r.data) {
              if (r.data.data) {
                this.items = r.data.data
              }
              if (r.data.status) {
                this.status = r.data.status
              }
            }

            this.$nextTick(() => {
              if (this.ps)
                this.ps.update()
            })
          })
          .catch(e => {
            this.isLoading = false
            this.$toast.open({
              message: `Error: ${e.message}`,
              type: 'is-danger'
            })
          })
      }
    }
  }
</script>

<style scoped>

</style>